// Copyright 2025, University of Maryland, All Rights Reserved

/** Convert unknown value to trimmed string or null if empty/invalid */
export const toStringOrNull = (value: unknown): string | null =>
  typeof value === 'string' && value.trim().length > 0 ? value : null
